import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
// import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

// core components

function CardBgImage() {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          color: theme.palette.white.main,
          backgroundColor: theme.palette.dark.main,
        }}
      >
        <Box
          component="img"
          alt="..."
          src={require("assets/img/theme/img-1-1000x600.jpg").default}
          sx={{
            borderTopLeftRadius: "calc(.375rem - 1px)",
            borderTopRightRadius: "calc(.375rem - 1px)",
            flexShrink: 0,
            width: "100%",
            verticalAlign: "middle",
            borderStyle: "none",
          }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: "1.25rem",
            borderRadius: "calc(.375rem - 1px)",
          }}
        >
          <div>
            <Typography
              variant="h2"
              sx={{
                marginBottom: ".5rem !important",
                color: theme.palette.white.main,
              }}
            >
              Card title
            </Typography>
            <Box
              component="p"
              sx={{
                marginBottom: "1rem",
                fontWeight: "300",
                lineHeight: "1.7",
                fontSize: "1rem",
                marginTop: "0",
              }}
            >
              This is a wider card with supporting text below as a natural
              lead-in to additional content. This content is a little bit
              longer.
            </Box>
            <Box
              component="p"
              sx={{
                marginBottom: "0",
                fontWeight: "600",
                lineHeight: "1.7",
                fontSize: ".875rem",
                marginTop: "0",
              }}
            >
              Last updated 3 mins ago
            </Box>
          </div>
        </Box>
      </Card>
    </>
  );
}

export default CardBgImage;
